import { Box, Paper, styled } from '@mui/material';

export const StatsGrid = styled(Box)(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(2, 1fr)',
  gap: theme.spacing(3),
  height: '100%',
  width: '100%',
}));

export const StatsCard = styled(Paper)(({ theme }) => ({
  height: '100%', // Added to fill grid row height
  padding: theme.spacing(3),
  borderRadius: '12px',
  boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.05)',
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'flex-start',
  gap: theme.spacing(3),
}));
